<template>
    <yd-list theme="4">
      <yd-list-item v-for="(article,key) in articleList" :key="key" class="article" type="link" :href="'/'+params.id+'/content/'+article.id">
        <span slot="title" class="title">{{article.title}}</span>
        <yd-list-other slot="other" class="info">
            <span v-html="article.summary"></span>
        </yd-list-other>
      </yd-list-item>
    </yd-list>
</template>

<script type="text/babel">
import axios from 'axios'
export default {
  data () {
    return {
      articleList: [],
      term: [],
      params: this.$route.params
    }
  },
  methods: {
    getContent () {
      let data = {fair_id: this.params.id, termid: this.params.termid}
      axios
        .post('/cat/search-ticket', data)
        .then(this.getContentSucc)
    },
    getContentSucc (res) {
      res = res.data
      if (res.status && res.data) {
        this.articleList = res.data
        this.term = res.term
      }
    },
    HistoryBack () {
      window.history.back()
    }
  },
  mounted () {
    this.getContent()
  }
}
</script>

<style lang="stylus" scoped>
  .yd-list-theme4
    background: none
  .article
    width: calc(100% - .4rem)
    border-radius: .2rem
    margin: 0 auto
    margin-bottom: .12rem
    padding: .4rem .2rem
    background-color: rgba(255,255,255,0.9)
    border-bottom: solid 1px #e0e0e0
    height: 2.4rem
  .article>:first-child
    display: none
  .article>:last-child
    padding: 0!important
    padding-left: .3rem!important
    position: relative
  .article>:last-child>:first-child
    -webkit-line-clamp: 1
    max-width: calc(100% - 0.6rem)
  .yd-list-theme4>:first-child
    margin-top: .2rem
  .title
    font-size: .32rem
    line-height: .28rem
    font-weight: normal
  .info
    font-size: .28rem
    line-height: .36rem
    margin-top: .36rem!important
    padding: 0!important
    padding-right: .3rem!important
  .info span
    max-width: 350px
    overflow: hidden
    display: -webkit-box
    -webkit-box-orient: vertical
    -webkit-line-clamp: 2
  .article>:last-child::before
    content: ""
    width: .12rem
    height: .12rem
    border-radius: 50%
    background-color: #00C800
    position: absolute
    left: 0.08rem
    top: .08rem
</style>



// WEBPACK FOOTER //
// src/views/template1/ArticleList.vue